// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar-module--avatar--1U71V"};